<div class="container greyTextContainer">
  
  <h1>Terms and Conditions</h1>
  <h2>
    1. Introduction
  </h2>

  <p>
    The Terms of Use of the ADIEM website include these Terms and Conditions, the Privacy Policy and any other terms and
    conditions that appear in or are linked to the ADIEM website (Additional Terms and Conditions).
  </p>

  <p>
    The Additional Terms and Conditions that appear on the ADIEM website will govern your use of, and access to, certain
    sections of the ADIEM Web Site where they appear. Since these Additional Terms and Conditions form part of the Terms
    of Use, you are bound by them and should review them wherever they are relevant to you when using the ADIEM website.
  </p>

  <h2>
    2. Website content and access
  </h2>

  <p>
    While ADIEM endeavours to take reasonable care in preparing and maintaining the information on this website we do
    not warrant the accuracy, reliability, adequacy or completeness of any of the website content. You acknowledge and
    accept that the website content may include technical inaccuracies and typographical errors. The website content is
    subject to change at any time without notice and may not necessarily be up to date or accurate at the time you view
    it.
  </p>

  <p>
    It is your responsibility to enquire with us directly to ensure the accuracy and currency of the material or
    information you seek to rely upon. To the extent permitted by law, including the Competition and Consumer Act 2010
    (Cth), ADIEM disclaims all liability for loss directly or indirectly arising from your use of or reliance on the
    website and the website content.
  </p>

  <p>
    ADIEM does not guarantee that access to the ADIEM website will be uninterrupted or that the website is free from
    viruses or anything else which may damage any computer which accesses the ADIEM website or any data on such a
    computer.
  </p>

  <h2>
    3. Limitation of liability
  </h2>

  <p>
    To the maximum extent permitted by law ADIEM excludes all liability for any loss or damage of any kind (including
    special, indirect or consequential loss and including loss of business profits) arising out of or in connection with
    the website content and the use or performance of the ADIEM website except to the extent that the loss or damage is
    directly caused by ADIEM's fraud or wilful misconduct.
  </p>

  <p>
    Where the law (including without limitation the Competition and Consumer Act 2010 (Cth)) implies a warranty or
    guarantee into these Website Terms and Conditions which may not lawfully be excluded, then provided it is fair and
    reasonable to do so, ADIEM's liability for breach of such a warranty or guarantee shall be limited at its option, to
    any one or more of the following:
  </p>

  <ol>
    <li>in the case of goods: replacement of the goods or the supply of equivalent goods; repair of the goods;
      payment of the cost of replacing the goods or acquiring equivalent goods; or payment of the cost of having the
      goods repaired; and
    </li>
    <li>in the case of services, to either resupplying the services or payment of the cost of having the services
      supplied again.
    </li>
  </ol>


  <h2>
    4. Intellectual property
  </h2>

  <p>
    The materials displayed on this website, including without limitation all editorial materials, information,
    photographs, illustrations, artwork and other graphic materials, and names, logos and trade marks, are the property
    of ADIEM and are protected by copyright, trade mark and other intellectual property laws. Any such content may be
    displayed and printed solely for your personal, non-commercial use within your organisation provided that any
    copyright notice on such a display or page is not removed. You agree not to reproduce, retransmit, distribute,
    disseminate, sell, publish, broadcast or circulate any such material to any third party without the express prior
    written consent of ADIEM.
  </p>

  <p>
    Save for the above, and unless expressly granted, ADIEM does not grant any licence or right in, or assign all or
    part of, its intellectual property rights in the content or applications incorporated into the ADIEM website or in
    the user interface of the ADIEM website.
  </p>


  <h2>
    5. Submissions
  </h2>

  <p>
    Any material you send to us on or via the ADIEM website will be deemed to be non-confidential and non-proprietary,
    unless it is indicated to be otherwise. This includes any data, questions, comments, suggestions, ideas or other
    information. We will be entitled to use any such material which has not been indicated to be confidential or
    proprietary for any purpose without compensation to you.
  </p>

  <h2>
    6. Third party websites
  </h2>

  <p>
    The ADIEM Website may contain links to other websites operated, controlled or produced by third parties. Unless
    otherwise indicated, ADIEM does not control, endorse, sponsor or approve any such third party websites or their
    content nor does ADIEM provide any warranty or take any responsibility whatsoever for any aspect of those websites
    or their content.
  </p>

  <h2>
    7. Links to ADIEM website
  </h2>

  <p>
    If you wish to establish a link to this website, you must first seek approval from ADIEM. To seek approval, please
    email ADIEM.
  </p>

  <p>
    The following information will be required to assess your request:
  </p>

  <ol>
    <li>the URL of the website that you seek to establish a link from</li>
    <li>a brief description of your website</li>
    <li>the reason that you wish to establish a link.</li>
  </ol>

  <p>
    If ADIEM agrees to your proposed link, you must comply with any terms and conditions imposed by ADIEM as a condition
    of such agreement. If the nature and/or content of your website changes in any significant way, you must contact
    ADIEM and provide a new description of your website.
  </p>

  <h2>
    8. Interference with website
  </h2>

  <p>
    You must not attempt to change, add to, remove, deface, hack or otherwise interfere with this website or any
    material or content displayed on the ADIEM website.
  </p>

  <h2>
    9. Jurisdiction
  </h2>

  <p>
    These Terms and Conditions are governed by and construed in accordance with the State of Victoria, Australia. In the
    event that a dispute arises from these Website Terms and Conditions, each of ADIEM and you agree to submit to the
    non-exclusive jurisdiction of the courts of Victoria, Australia.
  </p>

  <div class="backButton">
    <button class="okBtn" mat-raised-button color="primary" (click)="back()">
      Back
    </button>
  </div>
</div>